import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pirConfluenceSectionHeader: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.confluence.pir-confluence-section-header',
		defaultMessage: 'CONFLUENCE SETTINGS',
		description: 'Header for confluence settings under "Post Incident Reviews"',
	},
	pirConfluenceSpaceDescription: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.confluence.pir-confluence-space-description',
		defaultMessage: 'Select a Confluence space to save exported post-incident reviews.',
		description:
			'Description about confluence space settings under "Post Incident Reviews" template',
	},
	pirConfluencePageDescription: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.confluence.pir-confluence-page-description',
		defaultMessage: 'Select a parent page to save exported post-incident reviews as a child page.',
		description:
			'Description about confluence page settings under "Post Incident Reviews" template',
	},
	pirConfluenceErrorFlagConfluenceSpace: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.confluence.pir-confluence-error-flag-confluence-space',
		defaultMessage: 'Something went wrong while fetching Confluence spaces. Please try again.',
		description: 'Error Fetching Confluence Spaces',
	},
	pirConfluenceErrorFlagConfluencePage: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.confluence.pir-confluence-error-flag-confluence-page',
		defaultMessage: 'Something went wrong while fetching Confluence pages. Please try again.',
		description: 'Error Fetching Confluence Pages',
	},
});
